import { color, font, size, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import TextareaAutosize from "react-textarea-autosize";
import styled from "styled-components";
export const TextArea = styled(TextareaAutosize) `
  & {
    box-sizing: border-box;
    background: transparent;
    font-size: ${size.font.base.m};
    line-height: ${size.lineHeight.base.m};
    border: 0 transparent;
    font-family: inherit;
    color: inherit;
    text-rendering: inherit;
    letter-spacing: inherit;
    word-break: break-word;
    scroll-padding-left: 0;
    scroll-padding-right: 0;
    overflow: hidden;
    margin: 0;
    resize: none;
    outline: none;
  }

  textarea::placeholder {
    cursor: text;
    font-family: ${font.brand.sansSerif.family};
    color: ${color.font.input.placeholder};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEFyZWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0QXJlYS9zdHlsZWQvVGV4dEFyZWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEtBQUssRUFDTCxJQUFJLEVBQ0osSUFBSSxHQUNMLE1BQU0sZ0RBQWdELENBQUM7QUFDeEQsT0FBTyxnQkFBZ0IsTUFBTSx5QkFBeUIsQ0FBQztBQUN2RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLGdCQUFnQixDQUFDLENBQUE7Ozs7aUJBSS9CLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7bUJBQ2QsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7bUJBaUJ0QixJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxNQUFNO2FBQ2pDLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFdBQVc7O0NBRXhDLENBQUMifQ==